import queryString from 'query-string';
import moment from 'moment';
import { DEFAULT_COUNTRY_CODE, DEFAULT_LANGUAGE_VARIANT } from '../constants';
import { utcDateFormats } from './enums';

export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export const getCountryCode = () => {
    const params = queryString.parse(location.search);
    return params.countryCode ? params.countryCode : DEFAULT_COUNTRY_CODE;
};

export const getLocale = () => {
    const params = queryString.parse(location.search);
    return params.locale ? params.locale : DEFAULT_LANGUAGE_VARIANT;
};

export const formatUtcDate = ({ type, date }) => {
    // Use the type to differentiate different formats
    if (type === utcDateFormats['DD-MM-YYYY']) {
        return moment(date).utc().format('DD-MM-YYYY');
    }

    if (type === utcDateFormats.YYYY) {
        return moment(date).utc().format('YYYY');
    }

    return date;
};



// WEBPACK FOOTER //
// ./app/helpers/utils.js